function create_new_message(msg) {
  const { alias, content } = msg;
  return {
    id: Date.now(),
    alias: alias || 'user',
    content,
    loading: false,
  };
}

function create_dummy_message(iteration) {
  const lorem =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
  const startIndex = Math.floor(Math.random() * lorem.length);
  const maxLength = Math.floor(Math.random() * (lorem.length - startIndex)) + 1;

  return {
    id: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
    alias: iteration % 2 === 0 ? 'user' : 'author',
    content: lorem.substring(startIndex, maxLength),
    loading: false,
  };
}

function create_dummy_messages(numberOfMessages) {
  const dummyMessages = [];
  for (let i = 0; i < numberOfMessages; i++) {
    dummyMessages.push(create_dummy_message(i));
  }
  return dummyMessages;
}

export {
  create_new_message as createNewMessage,
  create_dummy_messages as createDummyMessages,
};
